import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import { BtnFavorite } from '../../../../../common/BtnFavorite/BtnFavorite.jsx';
import { BtnIcon } from '../../../../../common/BtnIcon/BtnIcon.jsx';
import { createInnerHtml } from '../../../../../../helpers/helpers';
import { getBSLImageURL } from '../../../../../../utils/utils';
// TODO: import stencil component: pes-ellipsis

/**
 * @typedef {import('../../../../../../stores/data/RelatedProducts/RelatedProductStore').default} RelatedProductStore
 */

export class _RelatedProduct extends Component {
  constructor(props) {
    super(props);
    const { relatedProductStore, optionsStore } = props;

    /** @type {RelatedProductStore} */
    this.productStore = relatedProductStore;
    this.channelSightBtnEnabled = optionsStore.isCartTransferAvailable;
  }

  render() {
    const { parentSkuID } = this.props;
    const {
      productSelfRef,
      pictureDocumentReferenceURL,
      pictureAltText,
      commerceRef,
      productDesc,
      productPrice,
      productCurrency
    } = this.productStore;

    return (
      <li>
        <a className="related-product" href={productSelfRef}>
          <img
            className="related-product__image js-lazy"
            data-src={getBSLImageURL(pictureDocumentReferenceURL, 64)}
            src={getBSLImageURL(pictureDocumentReferenceURL, 64)}
            alt={pictureAltText}
          />
          <div className="related-product__content">
            <span className="related-product__title">{commerceRef}</span>
            <p className="related-product__desc">{productDesc}</p>          
            {productPrice
              && (
                <span className="related-product__price">
                  {productPrice}
                  {' '}
                  {productCurrency}
                </span>
              )}
            {this.channelSightBtnEnabled
              ? (<BtnIcon handleClick={() => this.productStore.addToCart(parentSkuID)} />)
              : (
                <BtnFavorite
                  handleClick={() => this.productStore.toggleFavorite(parentSkuID)}
                  store={this.productStore}
                />
              )}
          </div>
        </a>
      </li>
    );
  }
}

_RelatedProduct.propTypes = {
  relatedProductStore: propTypes.shape({
    productSelfRef: propTypes.string.isRequired,
    pictureDocumentReferenceURL: propTypes.string.isRequired,
    pictureAltText: propTypes.string.isRequired,
    commerceRef: propTypes.string.isRequired,
    productDesc: propTypes.string.isRequired,
    productPrice: propTypes.string,
    productCurrency: propTypes.string
  }).isRequired,

  optionsStore: propTypes.shape({
    isCartTransferAvailable: propTypes.bool.isRequired
  }).isRequired,

  parentSkuID: propTypes.string.isRequired
};

export const RelatedProduct = inject((allStores, props) => ({
  relatedProductStore: allStores.relatedRootStore.getRelatedProductStore(props.skuID),
  optionsStore: allStores.optionsStore
}))(observer(_RelatedProduct));
